<div class="pill" [ngClass]="pricingStatus?.code">
    {{pricingStatus?.name}} {{pricingStatus?.code == 'DealDeskPricing' ? 'Selections' : ''}}
</div>
